export default __webpack_public_path__ + "media/images/manual/joanr/05-cdc3cc04775da83d298f5020ef4d5faa.png";